/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Continuewithgoogle2Inputs */

const he_auth_login_continuewithgoogle2 = /** @type {(inputs: Auth_Login_Continuewithgoogle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המשך עם Google`)
};

const en_auth_login_continuewithgoogle2 = /** @type {(inputs: Auth_Login_Continuewithgoogle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Auth_Login_Continuewithgoogle2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_login_continuewithgoogle2 = /** @type {((inputs?: Auth_Login_Continuewithgoogle2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Continuewithgoogle2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_login_continuewithgoogle2(inputs)
	return en_auth_login_continuewithgoogle2(inputs)
});
export { auth_login_continuewithgoogle2 as "auth_login_continueWithGoogle" }